import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetPasswordRequest } from '@cash-web/shared-util-protos/squareup/cash/security/api.pb'
import { SetPasswordResponse } from '@cash-web/shared-util-protos/squareup/cash/security/api.pb'

export const setPassword = (request: SetPasswordRequest, options?: CashRequestOptions) =>
  post<SetPasswordRequest, SetPasswordResponse>('/2.0/cash/set-password', request, { ...options, rejectOnError: true })
